import * as taskHelpers from 'resources/task/task.helpers';

const moveTasksWithinMilestone = ({
  milestone,
  sIndex,
  dIndex,
}) => {
  const documentRequests = milestone.tasks.filter((t) => taskHelpers.isDocumentRequest(t));
  const nonDocumentRequests = milestone.tasks.filter((t) => !taskHelpers.isDocumentRequest(t));
  
  // move the task to the new index
  const [removed] = nonDocumentRequests.splice(sIndex, 1);
  nonDocumentRequests.splice(dIndex, 0, removed);

  const updatedTasks = [...nonDocumentRequests, ...documentRequests];

  return { ...milestone, tasks: updatedTasks };
};

const moveTaskToAnotherMilestone = ({
  sMilestone,
  dMilestone,
  sIndex,
  dIndex,
}) => {
  const sourceClone = Array.from(sMilestone.tasks);
  const destClone = Array.from(dMilestone.tasks);
  const [removedTask] = sourceClone.splice(sIndex, 1);

  destClone.splice(dIndex, 0, { ...removedTask, milestone_id: dMilestone.id });

  return [
    { ...sMilestone, tasks: sourceClone },
    { ...dMilestone, tasks: destClone },
  ];
};

export const reorderTasks = (tasks) => {
  const documentRequests = tasks.filter((t) => taskHelpers.isDocumentRequest(t));
  const nonDocumentRequests = tasks.filter((t) => !taskHelpers.isDocumentRequest(t));

  return [
    ...nonDocumentRequests.map((task, index) => ({
      ...task,
      milestone_order: index,
    })),
    ...documentRequests.map((task) => ({
      ...task,
      milestone_order: -1,
    })),
  ];
};

const reorderMilestonesTasks = (milestones) => milestones.map((milestone) => ({
  ...milestone,
  tasks: reorderTasks(milestone.tasks),
}));

export const getUpdatedMilestones = ({
  sMilestone,
  dMilestone,
  sIndex,
  dIndex,
}) => {
  if (sMilestone.id === dMilestone.id) {
    const updatedMilestone = moveTasksWithinMilestone({
      milestone: sMilestone,
      sIndex,
      dIndex,
    });

    return reorderMilestonesTasks([updatedMilestone]);
  }

  const updatedMilestones = moveTaskToAnotherMilestone({
    sMilestone,
    dMilestone,
    sIndex,
    dIndex,
  });

  return reorderMilestonesTasks(updatedMilestones);
};
